"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Menus;
const react_1 = __importDefault(require("react"));
const dropdown_context_1 = require("./dropdown-context");
const menu_expander_1 = __importDefault(require("./menu-expander/menu-expander"));
const upper_menu_1 = __importDefault(require("./upper-menu/upper-menu"));
const logo_1 = __importDefault(require("./logo/logo"));
const main_menu_1 = __importStar(require("./main-menu/main-menu"));
const data_1 = require("~/helpers/data");
const classnames_1 = __importDefault(require("classnames"));
const trapTab_1 = __importDefault(require("~/helpers/trapTab"));
require("./menus.scss");
const events_1 = require("~/helpers/events");
function Menus() {
    const ref = react_1.default.useRef(null);
    const [active, toggle] = (0, data_1.useToggle)();
    const expandMenu = react_1.default.useCallback(() => toggle(), [toggle]);
    const clickOverlay = react_1.default.useCallback((event) => {
        if (event.currentTarget === event.target) {
            expandMenu();
        }
    }, [expandMenu]);
    const closeOnEsc = react_1.default.useCallback((event) => {
        if (active && event.key === 'Escape') {
            expandMenu();
        }
    }, [active, expandMenu]);
    react_1.default.useEffect(() => {
        const tabListener = (0, trapTab_1.default)(ref.current);
        if (active) {
            document.addEventListener('keydown', tabListener, true);
        }
        else {
            document.removeEventListener('keydown', tabListener, true);
        }
        return () => window.removeEventListener('keydown', tabListener, true);
    }, [active]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(dropdown_context_1.DropdownContextProvider, null,
            react_1.default.createElement("div", { className: 'menus desktop' },
                react_1.default.createElement("nav", { className: 'meta-nav' },
                    react_1.default.createElement(upper_menu_1.default, null)),
                react_1.default.createElement("nav", { className: 'nav', "aria-label": 'Main menu' },
                    react_1.default.createElement("div", { className: 'container' },
                        react_1.default.createElement(logo_1.default, null),
                        react_1.default.createElement(main_menu_1.default, null))))),
        react_1.default.createElement(dropdown_context_1.DropdownContextProvider, { contextValueParameters: { prefix: 'mobile' } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('menus mobile', { active }), ref: ref, onKeyDown: closeOnEsc },
                react_1.default.createElement(logo_1.default, null),
                react_1.default.createElement(menu_expander_1.default, { active: active, onClick: expandMenu, "aria-controls": 'menu-popover', "aria-expanded": active }),
                react_1.default.createElement("div", { className: 'menu-popover-overlay', onClick: clickOverlay },
                    react_1.default.createElement("div", { id: 'menu-popover', className: 'menu-popover' },
                        react_1.default.createElement("div", { className: 'menu-title' }, "Menu"),
                        react_1.default.createElement("ul", { className: 'no-bullets', onKeyDown: events_1.treatSpaceOrEnterAsClick },
                            react_1.default.createElement(main_menu_1.MainMenuItems, null),
                            react_1.default.createElement(upper_menu_1.default, null))))))));
}
